import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FIND_PURCHASE = function (state, payload) {
  payload.forEach(x => {
    switch (x.is_accept) {
      case 0:
        state.rows_pending_input.push(x)
        break
      case 1:
        state.rows_pending_quote.push(x)
        break
      case 2:
        state.rows_quoted.push(x)
        break
    }
  })
}

mutations.RESET_PURCHASE = function (state) {
  state.rows_pending_input = []
  state.rows_pending_quote = []
  state.rows_quoted = []
}

const state = {
  rows: [],
  row: {},
  condition: {},
  rows_pending_input: [],
  rows_pending_quote: [],
  rows_quoted: []
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0004Purchase cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0004PurchaseMasterService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo('暫無資料')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchPurchase: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase search')
    return client.postData({ data: { searchPurchase: { api: 'M0004PurchaseMasterService.searchPurchase', input: condition } } })
      .then((data) => {
        commit('FIND_PURCHASE', data.searchPurchase.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0004Purchase add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0004Purchase edit')
    return client.postData({ data: { find: { api: 'M0004PurchaseMasterService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0004Purchase delete')
    return client.postData({ data: { delete: { api: 'M0004PurchaseMasterService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0004Purchase save')
    return client.postData({ data: { save: { api: 'M0004PurchaseMasterService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase download')
    return client.download({ data: { download: { api: 'M0004PurchaseMasterService.downloadData', input: condition } } })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
